<template>
    <games-general-settings
        v-if="client"
        :games-settings="client.settings.gamesSettings"
        :save-games-settings="(settings) => { save(settings); }"
    />
</template>
<script>
import state from '../../../../state';
import utils from '../../../../utils';
import clientService from '../../../../services/client.service';

import GamesGeneralSettings from '../../../common/games-general-settings.vue';

export default {
    name: 'client-games-general',
    components: { GamesGeneralSettings },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async created() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save(gamesSettings) {
            this.client.settings.gamesSettings = gamesSettings;
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/games/general.vue